import lowerFirst from './lower-first';
/**
 * @param {string} prefix
 * @param {string} value
 */

var unprefixPropName = function unprefixPropName(prefix, value) {
  return lowerFirst(value.replace(prefix, ''));
};

export default unprefixPropName;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/unprefix-prop-name.js
// module id = 1022
// module chunks = 1